import { gql } from '@graphql/__generated__';

export const GET_VISIBILITY_INBOX_PROFILE_LEAD_HISTORY = gql(/* GraphQL */ `
  query GetVisibilityInboxProfileLeadHistory($teamId: uuid!) {
    visibility_inbox_profile_lead_history(
      where: { team_id: { _eq: $teamId } }
      order_by: { created_at: desc }
    ) {
      anonymized_contact
      contact_reason
      created_at
      id
      recipient_name
    }
  }
`);

export const GET_VISIBILITY_INBOX = gql(/* GraphQL */ `
  query GetVisibilityInbox(
    $id: uuid
    $contactRequestsWhere: enquiries_bool_exp!
  ) {
    visibility_inbox_lead_agents(
      where: { team_id: { _eq: $id }, lead: {} }
      order_by: { created_at: desc }
    ) {
      id
      created_at
      lead_id
      contact_reason
      lead {
        anonymized_contact
        appraisal_reason
        created_by
        origin_enquiry_id
        contact {
          ...UserInfo_user
        }
        origin_enquiry {
          ...UserInfo_enquiry
          contact_reason
          message
        }
        lead_agents(order_by: { created_at: desc }) {
          id
          claimed_at
          passed_at
          user_id
          user {
            full_name
            teams_users(where: { team_id: { _eq: $id } }) {
              team_id
            }
          }
        }
      }
      user {
        ...UserInfo_user
      }
    }
    enquiries(where: $contactRequestsWhere, order_by: { created_at: desc }) {
      ...UserInfo_enquiry
      id
      created_at
      updated_at
      user {
        ...UserInfo_user
      }
      first_name
      last_name
      phone_number
      email_address
      contact_reason
      message
      broker {
        full_name
      }
      team {
        name
      }
    }
  }
`);

export const GET_INBOX_MESSAGE = gql(/* GraphQL */ `
  query GetInboxMessage($id: uuid!) {
    visibility_inbox_lead_agents(
      where: {
        _or: [
          { id: { _eq: $id } }
          { lead: { origin_enquiry_id: { _eq: $id } } }
        ]
      }
      limit: 1
    ) {
      id
      lead_id
    }
    enquiries_by_pk(id: $id) {
      updated_at
      user {
        full_name
      }
      ...ContactRequestEnquiry
    }
  }
`);
